// BlogShow.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import "./Blogs_Show.css";
export const BlogShow = () => {
  const [blogs, setBlogs] = useState([]);
  const [allBlogs, setAllBlogs] = useState([]);
  const [deleteBlogId, setDeleteBlogId] = useState(null);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigate = useNavigate();

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString(undefined, options);
  };
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getAllBlogs = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setAllBlogs(data);
      setBlogs(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteBlog = async () => {
    const blogId = deleteBlogId;
    try {
      // Perform the delete operation using the blogId
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/delete/${blogId}`,
        
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      handleCloseDeleteDialog();
      // Refresh the blog list
      getAllBlogs();
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenDeleteDialog = (blogId) => {
    setDeleteBlogId(blogId);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteBlogId(null);
  };

  useEffect(() => {
    getAllBlogs();
  }, []);

  const handleCreateNewBlog = () => {
    navigate("/blog/create");
  };

  return (
    <div>
      <div className="banner">
        <div
          style={{ fontSize: "2rem", fontWeight: "500", marginBottom: "1rem" }}
        >
          Blogs:
        </div>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleCreateNewBlog}
          style={{ marginBottom: "1.5rem" }}
        >
          Create New Blog
        </Button>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "gainsboro" }}>
            <TableRow>
              <TableCell>Title</TableCell>
              {/* <TableCell>Author</TableCell> */}
              <TableCell>Published Date</TableCell>
              <TableCell>Tags</TableCell>
              <TableCell>Like Count</TableCell>
              <TableCell>Read Time (minutes)</TableCell>
              <TableCell>Action</TableCell>
              {/* Add more columns based on your blog data */}
            </TableRow>
          </TableHead>
          <TableBody>
            {blogs.map((blog) => (
              <TableRow key={blog._id}>
                <TableCell>{blog.title}</TableCell>
                {/* <TableCell>{blog.user_id.name}</TableCell> */}
                <TableCell>{formatDate(blog.time)}</TableCell>
                <TableCell>{blog.tags}</TableCell>
                <TableCell>{blog.like}</TableCell>
                <TableCell>{blog.read_time}</TableCell>
                <TableCell>
                  <Button
                    component={Link}
                    to={`/blog/${blog._id}`}
                    variant="contained"
                    color="primary"
                  >
                    <VisibilityIcon />
                  </Button>
                  <Button
                    component={Link}
                    to={`/blog/${blog._id}/edit`}
                    variant="contained"
                    color="warning"
                  >
                    <EditIcon />
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleOpenDeleteDialog(blog._id)}
                  >
                    <DeleteIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this blog?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteBlog} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
